export interface LayerOptions {
    visible?: boolean;
    opacity?: number;
    zIndex?: number;
}

export interface RssiGradientConfig {
    minRSSI: number;
    midRSSI: number;
    maxRSSI: number;
}

export type RssiRangeConfig = RssiGradientConfig;

export const LAYER_TYPES = {
    RSSI_GRADIENT: 'rssi-gradient',
    MARKERS_LEGEND: 'markers-legend',
    ACCESS_POINTS_INFO: 'access-points-info',
    MESH_POINTS: 'mesh-points'
} as const;

export const DEFAULT_RSSI_RANGE: RssiRangeConfig = {
    minRSSI: -90,
    midRSSI: -60,
    maxRSSI: -30
};
